/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {downloadExportInternal} from '../api'

export const useMutationDownloadExportInternal = createReactQueryMutationHook('downloadExportInternal', downloadExportInternal)
